import { render, staticRenderFns } from "./Activeplan.vue?vue&type=template&id=6e10338e&scoped=true&"
import script from "./Activeplan.vue?vue&type=script&lang=js&"
export * from "./Activeplan.vue?vue&type=script&lang=js&"
import style0 from "./Activeplan.vue?vue&type=style&index=0&id=6e10338e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e10338e",
  null
  
)

export default component.exports